import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import * as PapeletaService from '../../axios_services/papeletasalida.service';

const formatTime12h = (time24) => {
    if (!time24) return '—';
    const [hrs, mins] = time24.split(':');
    let h = parseInt(hrs, 10);
    const m = mins.substring(0, 2);
    const ampm = h >= 12 ? 'PM' : 'AM';
    h = h % 12 || 12;
    return `${String(h).padStart(2, '0')}:${m} ${ampm}`;
};

const ModalRechazarPapeleta = ({ isOpen, onClose, papeleta, tipo, onRefresh }) => {
    const [observaciones, setObservaciones] = useState('');
    const [saving, setSaving] = useState(false);

    useEffect(() => {
        if (isOpen) {
            setObservaciones('');
        }
    }, [isOpen, papeleta?.papeleta_id]);

    const handleRechazar = async () => {
        if (!observaciones.trim()) {
            alert('Ingrese el motivo del rechazo.');
            return;
        }
        if (!window.confirm('¿Confirma el rechazo de esta papeleta?')) return;
        setSaving(true);
        try {
            if (tipo === 'rechazar_jefe') {
                await PapeletaService.rechazarJefe({ papeleta_id: papeleta.papeleta_id, observaciones });
            } else {
                await PapeletaService.rechazarTH({ papeleta_id: papeleta.papeleta_id, observaciones });
            }
            onRefresh();
            onClose();
        } catch (err) {
            alert(err.response?.data?.error || 'Error al rechazar.');
        } finally {
            setSaving(false);
        }
    };

    if (!papeleta) return null;

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static">
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>RECHAZAR PAPELETA</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>

            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <Form className="fila" onSubmit={e => e.preventDefault()}>

                        {/* Info de referencia */}
                        <FormGroup>
                            <Label>Colaborador:</Label>
                            <Input
                                className="form-control"
                                type="text"
                                value={papeleta.nombre_empleado || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Fecha de Salida:</Label>
                            <Input
                                className="form-control"
                                type="text"
                                value={papeleta.fecha_salida || ''}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label>Hora de Salida:</Label>
                            <Input
                                className="form-control"
                                type="text"
                                value={formatTime12h((papeleta.hora_salida || '').substring(0, 5))}
                                readOnly
                                style={{ background: '#f3f4f6', cursor: 'default' }}
                            />
                        </FormGroup>

                        {/* Motivo de rechazo */}
                        <FormGroup>
                            <Label>Motivo de rechazo: *</Label>
                            <Input
                                className="form-control"
                                type="textarea"
                                rows={3}
                                value={observaciones}
                                onChange={e => setObservaciones(e.target.value)}
                                placeholder="Ingrese el motivo del rechazo..."
                            />
                        </FormGroup>

                        {/* Botón */}
                        <FormGroup style={{ marginTop: '18px' }}>
                            <div className="button-container">
                                <Button
                                    className="button-custom"
                                    onClick={handleRechazar}
                                    disabled={saving}
                                >
                                    {saving ? 'REGISTRANDO...' : 'REGISTRAR'}
                                </Button>
                            </div>
                        </FormGroup>

                    </Form>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalRechazarPapeleta;
